import { lazyRoute } from './lazy-route';
import { sectionChildren } from './section-index-redirect';

import type { RouteObject } from 'react-router-dom';

// /coverage-request/review/overview
const coverageRequestsOverview = lazyRoute(
  'overview',
  () => import('@/features/coverage-req/binding-request-overview'),
  { handle: { label: 'Overview', icon: 'Inbox' } }
);

// /coverage-request/review/historical
const coverageRequestsHistorical = lazyRoute(
  'historical',
  () => import('@/features/coverage-req/binding-requests-historical'),
  { handle: { label: 'Historical', icon: 'History' } }
);

// /coverage-request/review
const coverageRequest = lazyRoute(
  '/coverage-request/review',
  () => import('@/features/coverage-req'),
  {
    children: sectionChildren([coverageRequestsOverview, coverageRequestsHistorical])
  }
);

// /review-request-coverage/:operationName/:refId
const reviewRequestCoverage = lazyRoute(
  '/review-request-coverage/:operationName/:refId',
  () => import('@/features/coverage-req/binding-request-from-mail')
);

export const coverageRequestRoutes: RouteObject[] = [coverageRequest, reviewRequestCoverage];
